var _path, _g, _path2, _path3, _g2, _path4, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 145C112.541 145 145 112.541 145 72.5C145 32.4594 112.541 0 72.5 0C32.4594 0 0 32.4594 0 72.5C0 112.541 32.4594 145 72.5 145Z",
    fill: "#DCE8F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_551_4521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0158 35.8818L137.263 22.6193L61.841 49.0757L40.6985 37.7289C40.516 37.6308 40.3689 37.4778 40.2781 37.2916C40.1872 37.1054 40.1573 36.8953 40.1923 36.6911C40.2274 36.4869 40.3258 36.2989 40.4736 36.1537C40.6214 36.0084 40.8111 35.9133 41.0158 35.8818Z",
    fill: "#FC6D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.263 22.6194L121.389 84.6132C121.351 84.7607 121.28 84.8974 121.18 85.0126C121.081 85.1277 120.956 85.2183 120.815 85.277C120.675 85.3357 120.522 85.3611 120.37 85.351C120.218 85.341 120.071 85.2959 119.939 85.2192L79.3493 61.5594L137.263 22.6194Z",
    fill: "#FC6D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8411 49.0757L72.2143 75.0885L79.3493 61.5594L137.263 22.6193L61.8411 49.0757Z",
    fill: "#FEC6C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2144 75.0886L86.6868 65.8375L79.3495 61.5595L72.2144 75.0886Z",
    fill: "#C8402F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9572 110.954C50.2393 110.903 48.5541 110.472 47.0231 109.691C45.4921 108.91 44.1535 107.799 43.1038 106.439C40.7435 103.415 40.2066 99.7284 41.5536 95.7339L41.6546 95.4476C33.433 97.317 25.5211 100.353 18.1594 104.464C17.9788 104.564 17.7801 104.629 17.5747 104.653C17.3693 104.677 17.1611 104.66 16.9622 104.604C16.7632 104.547 16.5773 104.452 16.4151 104.324C16.2528 104.196 16.1174 104.037 16.0166 103.856C15.9158 103.675 15.8516 103.477 15.8276 103.271C15.8036 103.066 15.8202 102.858 15.8767 102.659C15.9331 102.46 16.0281 102.274 16.1564 102.112C16.2847 101.949 16.4436 101.814 16.6242 101.713C25.0167 97.0291 34.0945 93.6958 43.524 91.836C45.0133 89.7138 46.9854 87.9758 49.2779 86.7652L67.4296 77.0967C67.7975 76.9036 68.2269 76.8639 68.624 76.9862C69.0211 77.1085 69.3537 77.383 69.5492 77.7496C69.7447 78.1162 69.7873 78.5453 69.6676 78.9432C69.5479 79.3411 69.2757 79.6756 68.9103 79.8735L50.7618 89.5422C49.9827 89.9557 49.2459 90.4445 48.562 91.0014C50.51 90.7523 52.2257 90.5771 53.6523 90.4804C55.7014 90.3348 57.7468 90.8107 59.5213 91.8457C61.2958 92.8808 62.7169 94.427 63.5989 96.2823C64.8665 99.0299 64.6856 101.965 63.0734 104.766C62.0692 106.52 60.6488 107.999 58.9377 109.074C57.2265 110.148 55.2772 110.785 53.2616 110.928C52.8276 110.96 52.3921 110.969 51.9572 110.954ZM45.4624 94.6755C45.0933 95.3358 44.7854 96.0284 44.5424 96.7447C43.5354 99.7115 43.8882 102.321 45.5906 104.501C46.4604 105.625 47.5968 106.515 48.8969 107.089C50.1971 107.664 51.62 107.905 53.0368 107.791C54.5378 107.683 55.9892 107.207 57.2632 106.406C58.5372 105.605 59.5948 104.503 60.3428 103.197C61.4534 101.264 61.5844 99.4356 60.7363 97.5996C60.1249 96.3214 59.1417 95.2576 57.9155 94.5476C56.6893 93.8376 55.2773 93.5145 53.8644 93.6207C51.0465 93.8183 48.2416 94.1704 45.4624 94.6755Z",
    fill: "#0056D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5323 96.0605C76.1844 96.0489 75.8502 95.9223 75.5819 95.7005C75.3137 95.4787 75.1265 95.1742 75.0498 94.8347C74.973 94.4952 75.011 94.1398 75.1578 93.8242C75.3046 93.5086 75.5519 93.2506 75.861 93.0905L97.2234 82.0535C97.4071 81.9586 97.6077 81.9008 97.8137 81.8834C98.0198 81.866 98.2272 81.8894 98.4242 81.9522C98.6212 82.0149 98.8039 82.1159 98.9619 82.2493C99.1199 82.3827 99.25 82.5459 99.3449 82.7296C99.4398 82.9133 99.4976 83.1139 99.515 83.3199C99.5324 83.526 99.509 83.7334 99.4463 83.9304C99.3835 84.1274 99.2825 84.3101 99.1491 84.4681C99.0157 84.6261 98.8525 84.7562 98.6688 84.8512L77.3065 95.8851C77.0677 96.0087 76.8011 96.0691 76.5323 96.0605Z",
    fill: "#0056D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4701 69.5229C45.1078 69.5119 44.7604 69.3762 44.4866 69.1387C44.2128 68.9011 44.0295 68.5764 43.9675 68.2192C43.9055 67.8621 43.9687 67.4945 44.1464 67.1786C44.3241 66.8627 44.6054 66.6178 44.9428 66.4854L55.8913 62.1913C56.2802 62.0374 56.7144 62.0443 57.0982 62.2105C57.4821 62.3767 57.7842 62.6886 57.9381 63.0775C58.092 63.4664 58.0851 63.9006 57.9189 64.2844C57.7527 64.6682 57.4408 64.9703 57.0519 65.1242L46.1035 69.4152C45.9021 69.4942 45.6864 69.5309 45.4701 69.5229Z",
    fill: "#0056D2"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_551_4521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 145,
    height: 145
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 145C112.541 145 145 112.541 145 72.5C145 32.4594 112.541 0 72.5 0C32.4594 0 0 32.4594 0 72.5C0 112.541 32.4594 145 72.5 145Z",
    fill: "#47EBE0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_551_4521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_551_4521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -8,
    width: 114,
    height: 139
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 130.254L-1.91165 114.802L91.0065 -7.59534L111.362 7.85694L18.4434 130.254Z",
    fill: "url(#paint0_linear_551_4521)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_551_4521)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.4434 130.254L-1.91165 114.802L91.0065 -7.59528L111.362 7.857L18.4434 130.254Z",
    fill: "url(#paint1_linear_551_4521)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_551_4521",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 22,
    width: 105,
    height: 132
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8106 153.665L33.6537 145.198L126.572 22.7949L137.723 31.2617L44.8106 153.665Z",
    fill: "url(#paint2_linear_551_4521)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_551_4521)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M44.811 153.665L33.6541 145.198L126.572 22.7949L137.723 31.2617L44.811 153.665Z",
    fill: "url(#paint3_linear_551_4521)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_551_4521",
    x: 11.8169,
    y: 22.6193,
    width: 129.446,
    height: 96.3414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_551_4521"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_551_4521",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_551_4521",
    x1: 43.0946,
    y1: 1.75724,
    x2: 66.3532,
    y2: 120.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996373,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5024,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_551_4521",
    x1: 43.0946,
    y1: 1.7573,
    x2: 66.3532,
    y2: 120.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_551_4521",
    x1: 74.886,
    y1: 32.8857,
    x2: 96.4936,
    y2: 143.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0996373,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2227,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5024,
    stopColor: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9705,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_551_4521",
    x1: 74.8864,
    y1: 32.8856,
    x2: 96.494,
    y2: 143.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmail);
export default __webpack_public_path__ + "static/media/check-email.3b16722ecccf530cf09375e8358b7ac5.svg";
export { ForwardRef as ReactComponent };